<template>
  <div>
    <el-dialog
      class="dialog-complaint"
      title="我要举报"
      :visible.sync="showModal"
      width="560px"
      appendToBody
    >
      <div>
        <div class="label">您为什么要举报此信息？</div>
        <div class="tags">
          <el-radio-group class="radio-group" v-model="tag">
            <el-radio :label="item.tag" v-for="item in tags" :key="item.tag">
              {{ item.name }}
            </el-radio>
          </el-radio-group>
        </div>
        <div class="label">举报说明（可选）</div>
        <div class="reason-wrap">
          <el-input
            type="textarea"
            v-model="reason"
            placeholder="详细描述举报理由......"
            :rows="7"
          ></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer clear">
        <el-button type="default" size="small" @click="showModal = false"> 取消 </el-button>
        <el-button type="primary" size="small" @click="confirm">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog class="dialog-ok" :visible.sync="showOkModal" width="480px" center appendToBody>
      <div>
        <img class="img-ok" src="@/assets/images/complaint/ok@2x.png" />
      </div>
      <div class="tip">您的投诉已提交，我们会尽快处理！</div>
      <div slot="footer" class="dialog-footer clear">
        <el-button type="primary" size="small" @click="showOkModal = false"> 知道了 </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'Complaint',
  data() {
    return {
      type: '',
      type_id: '',
      showModal: false,
      rules: {},
      model: {},
      tags: [],
      tag: '',
      reason: '',
      showOkModal: false,
    };
  },
  async created() {
    this.tags = await this.$http.get('/api/app/complaint/tags');
  },
  methods: {
    async show(type, type_id) {
      if (!this.$store.state.user_info.id) {
        this.$router.push({ name: 'Login' });
        return;
      }
      this.type = type;
      this.type_id = type_id;
      this.tag = '';
      this.reason = '';
      this.showModal = true;
    },
    async confirm() {
      if (this.tag == '') {
        this.$info('请选择举报原因');
        return;
      }
      await this.$http.post('/api/app/complaint', {
        type: this.type,
        type_id: this.type_id,
        tag: this.tag,
        reason: this.reason,
      });
      this.showModal = false;
      this.showOkModal = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-complaint {
  ::v-deep {
    .el-dialog {
      padding: 20px 24px 24px 24px;
    }
    .el-dialog__header {
      padding: 0;
      margin-bottom: 29px;
    }
    .el-dialog__title {
      font-size: 18px;
      color: rgba(59, 60, 62, 1);
      line-height: 1;
      display: block;
    }
    .el-dialog__headerbtn {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__footer {
      padding: 24px 0 0 0;
      .el-button {
        padding: 10px 30px;
        font-size: 14px;
      }
    }
  }

  .label {
    font-size: 14px;
    color: rgba(59, 60, 62, 1);
    line-height: 1;
  }

  .tags {
    margin-top: 22px;
    margin-bottom: 25px;
  }

  .radio-group {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    ::v-deep {
      .el-radio {
        margin-right: 0;
        width: 25%;
        margin-bottom: 10px;
        white-space: normal;
      }
      .el-radio__label {
        color: #7e7e80;
      }
    }
  }

  .reason-wrap {
    margin-top: 16px;
  }
}
.dialog-ok {
  ::v-deep {
    .el-dialog {
      padding: 27px 0 22px 0;
    }
    .el-dialog__headerbtn,
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      text-align: center;
    }
    .el-dialog__footer {
      padding: 0;
      .el-button {
        padding: 10px 44px;
      }
    }
  }
  .tip {
    font-size: 16px;
    color: rgba(59, 60, 62, 1);
    line-height: 1;
    margin-bottom: 26px;
  }
  .img-ok {
    width: 120px;
    margin-bottom: 24px;
  }
}
</style>
